"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHeaderMenu = void 0;
var components_1 = require("@wordpress/components");
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledHeaderMenu = (0, styled_components_1.default)(components_1.__experimentalNavigationMenu)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    margin: 0;\n  }\n"], ["\n  &&& {\n    margin: 0;\n  }\n"])));
var templateObject_1;
